{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "transformation": {
      "type": "object",
      "properties": {
        "prefix": {
          "type": "string"
        },
        "static": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "from": {
                "type": "string"
              },
              "to": {
                "type": "string"
              }
            }
          }
        },
        "ignore": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "pool": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      }
    },
    "debug": {
      "type": "object",
      "properties": {
        "stats": {
          "type": "boolean"
        }
      }
    }
  }
}
